// Copyright (c) 2016 Deere & Company

import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import t from 'tcomb';

const PartReturns = t.list(PartReturn, 'PartReturns');

export const getDefaultState = () => new PartReturns([]);

export default PartReturns;



// WEBPACK FOOTER //
// ./src/part-requests/shared/state/part-returns.js